import { NotificationService } from 'src/app/services/notification.service';
import { DropDownListDTO } from './../../../entity/dto/dropdownlist.component';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { FormularioService } from 'src/app/services/formulario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { GeneralService } from 'src/app/services/general.service';
import { GeneralComponent } from 'src/app/shared/general.component';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-qua007-card-VI',
    templateUrl: './qua007-card-VI.component.html'
})

export class Qua007CardVIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;
    public filteredUltimaCargaOptions: Observable<DropDownListDTO[]>;
    public filteredFxAzulCampoOptions: Observable<DropDownListDTO[]>;
    public listUltimaCargaOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxAzulCampoOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listUltimaCarga?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxAzulCampo?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxQualFisOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxQualFis?: Array<DropDownListDTO> = new Array<DropDownListDTO>();

    public listFxQualGen?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public listFxQualGenOriginal?: Array<DropDownListDTO> = new Array<DropDownListDTO>();
    public readOnlyUser?: boolean;

    @Output() objFxAzulGeral = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Etapa 6', false);

        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Fx_azul_campo: [null, []],
                Fx_azul_umidade: [null, []],
                Fx_azul_temperatura: [null, []],
                Fx_azul_tempo_nmonitorado: [null, []],
                Fx_azul_transbordo: [null, []],
                Fx_azul_geral: [null, []],
                Faixa_qualidade_fisica: [null, []],

                faixa_laranja: [null, []],
                faixa_cinza: [null, []],
                criado_por: [null, []],
                Resp_lancamento: [null, []],
                Observacao: [null, []],
                Sem_colheita_sequencia: [null, []],
                // Ultima_carga: [null, []],
                Sem_colheita_data: [null, []],
                Tonhrlanes: [null, []],
            });
        }
        else {
            this.step = 'Dados Gerais'

            this.formulario = this.formBuilder.group({


                criado_por: [null, [Validators.required]],
                Resp_lancamento: [null, [Validators.required]],
                Observacao: [null, [Validators.required]],
                Sem_colheita_sequencia: [null, [Validators.required]],

                Sem_colheita_data: [null, [Validators.required]],


                houve_desvio_documentacao: [null, [Validators.required]]
            });

        }
    }

    async ngOnInit(): Promise<void> {

        if (this.isComercial || this.isBasica) {

            await this.getLists();

        }
        else {

            await this.getListsPreBasic();
        }

    }


    async getFormFagData($event: any): Promise<void> {
        this.objFxAzulGeral.emit();
    }

    async getLists(): Promise<void> {
        await this.getListUltimaCarga();
        await this.getListFxAzulCampo();
        await this.getListFxQualFis();
    }
    async getListsPreBasic() {
        await this.getListHouveDesvio();
    }

    // async getFilters(): Promise<void> {
    //     await this.createFilterUltimaCarga();
    //     await this.createFilterFxAzulCampo();
    // }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    createFilterUltimaCarga(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listUltimaCargaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listUltimaCarga = this.listUltimaCargaOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listUltimaCarga = this.listUltimaCargaOriginal;
            }
        } else {
            this.listUltimaCarga = this.listUltimaCargaOriginal;
        }
        // this.filteredUltimaCargaOptions = this.formulario.get('Ultima_carga').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listUltimaCarga, value))
        //     );
    }



    createFilterFxQualFis(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxQualFisOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxQualFis = this.listFxQualFisOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxQualFis = this.listFxQualFisOriginal;
            }
        } else {
            this.listFxQualFis = this.listFxQualFisOriginal;
        }
    }

    async getListFxQualGen(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite()
        await this.formularioService.getListDropDownList('qua007', 'faixa_qualidade_genetica', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxQualGen = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxQualGenOriginal = this.listFxQualGen;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }


    createFilterFxQualGen(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxQualGenOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxQualGen = this.listFxQualGenOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxQualGen = this.listFxQualGenOriginal;
            }
        } else {
            this.listFxQualGen = this.listFxQualGenOriginal;
        }
    }



    private async getListUltimaCarga(): Promise<void> {
        await this.formularioService.getListDropDownList('qua007', 'ultima_carga').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listUltimaCarga = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listUltimaCargaOriginal = this.listUltimaCarga;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    private async getListFxAzulCampo(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite()
        await this.formularioService.getListDropDownList('qua007', 'faixa_azul_campo', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxAzulCampo = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxAzulCampoOriginal = this.listFxAzulCampo;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }

    async getListFxQualFis(): Promise<void> {
        const site = this.generalService.getLocalStorageDataSite()
        await this.formularioService.getListDropDownList('qua007', 'faixa_qualidade_fisica', site).pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxQualFis = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxQualFisOriginal = this.listFxQualFis;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }




    createFilterFxAzulCampo(value: string): void {
        if (!!value && value.length > 0) {
            if (this.listFxAzulCampoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase())).length > 0) {
                this.listFxAzulCampo = this.listFxAzulCampoOriginal.filter(x => x.name?.toLowerCase().includes(value?.toLowerCase()));
            } else {
                this.listFxAzulCampo = this.listFxAzulCampoOriginal;
            }
        } else {
            this.listFxAzulCampo = this.listFxAzulCampoOriginal;
        }

        // this.filteredFxAzulCampoOptions = this.formulario.get('Fx_azul_campo').valueChanges
        //     .pipe(
        //         startWith(''),
        //         map(value => this.generalService._filterDropDownList(this.listFxAzulCampo, value))
        //     );
    }

    async getListHouveDesvio() {
        await this.formularioService.getListDropDownList('qua007', 'houve_desvio_documentacao').pipe(take(1)).toPromise().then((response: any) => {
            if (!!response?.data) {
                this.listFxQualFis = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
                this.listFxQualFisOriginal = this.listFxQualFis;
            }
        }).catch(async (error: HttpErrorResponse) => {
            this.notificationService.showNotificationError(error, error.message);
        });
    }
}
